var map = {
	"./arablau/logo-login.png": 3945,
	"./dicas/logo-login.png": 3817,
	"./dicas/logo-login.svg": 6176,
	"./ghgorbis/logo-login.png": 4408,
	"./inpacs/logo-login.svg": 8553,
	"./maripol/logo-login.png": 9428,
	"./orbishigiene/logo-login.png": 6023,
	"./pedrosa/logo-login.png": 6727,
	"./prisma/logo-login.png": 2580,
	"./vario/logo-login.png": 5407,
	"./vario/logo-login.svg": 8322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6365;